import {ReactElement, useContext, useEffect, useMemo, useRef, useState} from "react";
import * as css from "./styles/propertyManagement.module.scss";
import useAppStore from "../../hooks/useAppStore";

import {Field, MediaInput} from '@zendeskgarden/react-forms';
import {ReactComponent as SearchIcon} from '@zendeskgarden/svg-icons/src/16/search-stroke.svg';

import "native-injects";
import Card from "../simplified-revenue/components/Card";
import {Property, useProperties} from "../../contexts/properties/PropertiesContext";
import PropertyReforecastStartBulkUpdater from "./components/PropertyReforecastStartBulkUpdater";
import {toast} from "react-toastify";
import {MONTHS} from "../../constants/Months";
import {AuthContext} from "../../contexts/AuthContext";
import {Body as TBody, Cell, Head, HeaderCell, HeaderRow, Row, Table} from "@zendeskgarden/react-tables";

type PropertyExt = Property;

export default function PropertyReforecastManagement(): ReactElement {
    const appStore = useAppStore();
    const auth = useContext(AuthContext);

    const {properties} = useProperties();
    const [filteredProperties, setFilteredProperties] = useState<PropertyExt[]>([]);
    const bodyRef = useRef(null);

    useEffect(
        () => {
            appStore.set({isLoading: false});
            return () => undefined;
        },
        []
    );

    useEffect(() => {
        setFilteredProperties(properties ?? []);
    }, [properties]);

    const tableBody = useMemo(() => {
        if (filteredProperties.length == 0) {
            return [];
        }

        const ret = filteredProperties.map(property => (
            <Row key={property.id}>
                <Cell className={`${css.cell}`}>
                    <div className={`${css.propertyNameCell}`}>
                        <span>{property.name}</span>
                    </div>
                </Cell>
                <Cell className={`${css.cell} ${css.periodCell}`}>{`${property.reforecastYear}-${MONTHS[property.reforecastStartMonthIndex]}`}</Cell>
            </Row>
        ));
        return ret;
    }, [filteredProperties]);

    function handleReforecastStartMonthUpdateComplete() {
        toast.success(`Reforecast Start Month successfully updated`);
        auth.reloadUserWithProperties();
    }

    return (
        <div className={css.wrapper}>
            <Card
                className={css.updaterControlsCard}
                titleClassName={css.updaterControlsTitle}
                title={"Bulk Update Property Reforecast Start"}
            >
                {properties ?
                    <PropertyReforecastStartBulkUpdater
                        properties={properties}
                        onUpdateCompleted={() => handleReforecastStartMonthUpdateComplete()}
                    />
                    :
                    <></>
                }

            </Card>

            <Card
                title={"Properties"}
                actions={
                    <div className={css.tableTopControls}>
                        <Field className={css.propertySearch}>
                            <MediaInput start={<SearchIcon />} placeholder="Search" onChange={e => {
                                if (!properties) {
                                    return;
                                }
                                setFilteredProperties(properties.filter(p => `${p.name}`.toLowerCase().includes(e.target.value.trim().toLowerCase())));
                            }} />
                        </Field>
                    </div>
                }
            >
                <div className={css.propertyTableWrapper}>
                    <Table className={css.propertyTable}>
                        <Head isSticky>
                            <HeaderRow className={css.headerCell}>
                                <HeaderCell className={`${css.cell} ${css.nameCell}`}>Property</HeaderCell>
                                <HeaderCell className={`${css.cell} ${css.periodCell}`}>Reforecast Start</HeaderCell>
                            </HeaderRow>
                        </Head>

                        <TBody ref={bodyRef}>
                            {tableBody}
                        </TBody>
                    </Table>
                </div>
            </Card>
        </div>
    );
}